import { Injectable } from '@angular/core';
import { Building } from '@edl-development/edl-common';
import { CustomFormUserFormDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-user-form-display-dto.model';

@Injectable()
export class CustomFormsSharedDataService {

    constructor() { }

    private _targetUserBuildings: Building[] = [];
    public get targetUserBuildings() {
        return this._targetUserBuildings;
    }

    private set targetUserBuildings(value: Building[] ) {
        this._targetUserBuildings = value;
    }

    private _userForm: CustomFormUserFormDisplayDTO | undefined;
    public get userForm() {
        return this._userForm;
    }

    private set userForm(value: CustomFormUserFormDisplayDTO | undefined) {
        this._userForm = value;
    }

    init({
        userForm,
        targetUserBuildings = []
    } : {
        userForm?: CustomFormUserFormDisplayDTO;
        targetUserBuildings?: Building[];
    }) {
        this.userForm = userForm;
        this.targetUserBuildings = targetUserBuildings;
    }
}
